import { render, staticRenderFns } from "./huzhuan.vue?vue&type=template&id=aec28010&scoped=true"
import script from "./huzhuan.vue?vue&type=script&lang=js"
export * from "./huzhuan.vue?vue&type=script&lang=js"
import style0 from "./huzhuan.vue?vue&type=style&index=0&id=aec28010&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec28010",
  null
  
)

export default component.exports